import styled from 'styled-components';

import { spaceL, spaceM, spaceS, scale000 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const StyledHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${spaceL} ${spaceL} ${spaceM};
`;

const StyledHeadline = styled(Headline)`
  margin-left: ${spaceS};
  margin-bottom: ${scale000};
`;

export const Styled = {
  Header: StyledHeader,
  Headline: StyledHeadline,
};
